import styles from './headerNav.module.scss';

const HeaderNav = () => {
  return (
    <>
      <header className={styles.header}>
        <div className={styles.gnb1000}>
          <div className={styles.gnb1000Child} />
          <img
            className={styles.hippocratNewLogoWhite2Icon}
            alt=""
            src="/header/hippocratnewlogo-white-2@2x.png"
          />
        </div>
      </header>
    </>
  );
};

export default HeaderNav;
